import React, { FC } from 'react'

import { IconBillPayPhoneProps } from './IconBillPayPhone.types'
import * as Styled from './styles/IconBillPayPhone.style'

import { nonThemeableRules } from '../../ruleSet'

const IconBillPayPhone: FC<IconBillPayPhoneProps> = ({
  size = nonThemeableRules.defaultSize as number as IconBillPayPhoneProps['size'],
  isResponsive = false,
}: IconBillPayPhoneProps) => {
  return (
    <Styled.IconWrapper size={size} isResponsive={isResponsive}>
      <svg fill='none' viewBox='0 0 48 48' xmlns='http://www.w3.org/2000/svg'>
        <g clipPath='url(#f07d2caa-80b0-4251-84dd-e44cae6c9690__a)' strokeLinecap='round' strokeWidth='2'>
          <path d='M21.01 39.008h6' stroke='#E60000' strokeLinejoin='round' />
          <path d='M17 5h18v34a4 4 0 0 1-4 4H17a4 4 0 0 1-4-4V9a4 4 0 0 1 4-4v0Z' stroke='#0D0D0D' strokeMiterlimit='10' />
          <path d='M31.055 17.02H23' stroke='#E60000' strokeLinejoin='round' />
          <path d='M31.055 23H23m8.055 6.075H23' stroke='#0D0D0D' strokeMiterlimit='10' />
          <path d='M19.025 17.02h-2.047' stroke='#E60000' strokeLinejoin='round' />
          <path d='M19.025 23.102h-2.047m2.047 5.936h-2.047' stroke='#0D0D0D' strokeMiterlimit='10' />
        </g>
        <defs>
          <clipPath id='f07d2caa-80b0-4251-84dd-e44cae6c9690__a'>
            <path d='M0 0h48v48H0z' fill='#fff' />
          </clipPath>
        </defs>
      </svg>
    </Styled.IconWrapper>
  )
}

export default IconBillPayPhone
